class TrendingSwatches extends HTMLElement {
  connectedCallback() {
    this.card = this.closest(".trending-product-card");

    const dataEl = this.querySelector("script[data-trending-variants]");
    this.variants = dataEl ? JSON.parse(dataEl.textContent) : [];

    this.selections = {};
    this.querySelectorAll("[data-option-position][data-selected]").forEach((button) => {
      this.selections[button.dataset.optionPosition] = button.dataset.optionValue;
    });

    this.updateAvailability();

    this.addEventListener("click", (event) => {
      const button = event.target.closest("[data-option-value]");
      if (!button) return;
      this.select(button);
    });
  }

  select(button) {
    const position = button.dataset.optionPosition;
    this.selections[position] = button.dataset.optionValue;
    this.markSelected(position, button);

    this.updateAvailability();
    this.applyVariant(this.getMatchedVariant());
  }

  markSelected(position, button) {
    this.querySelectorAll(`[data-option-position="${position}"]`).forEach((b) => {
      b.removeAttribute("data-selected");
    });
    button.setAttribute("data-selected", "");
  }

  // A value is in stock if some variant carries it at its position, is
  // itself available, and matches every OTHER currently selected option.
  // This only drives the sold-out visual indicator — every value stays
  // clickable so shoppers can see that variant's price/image even when
  // it's out of stock; only the add-to-cart button gets disabled for it.
  isValueInStock(button) {
    const position = button.dataset.optionPosition;
    const value = button.dataset.optionValue;

    return this.variants.some((variant) => {
      if (variant.options[position - 1] !== value) return false;
      if (!variant.available) return false;
      return Object.keys(this.selections).every((pos) => {
        if (pos === position) return true;
        return variant.options[pos - 1] === this.selections[pos];
      });
    });
  }

  updateAvailability() {
    this.querySelectorAll("[data-option-value]").forEach((button) => {
      button.classList.toggle("opacity-0_7", !this.isValueInStock(button));
    });
  }

  getMatchedVariant() {
    return this.variants.find((variant) =>
      Object.keys(this.selections).every((pos) => variant.options[pos - 1] === this.selections[pos])
    );
  }

  applyVariant(variant) {
    if (!this.card) return;
    const submitButton = this.card.querySelector('product-form button[type="submit"]');

    // No variant matches this exact combination at all (rare — only
    // possible if that combo was never created as a variant). Nothing to
    // show or add, so just keep the button disabled.
    if (!variant) {
      if (submitButton) submitButton.disabled = true;
      return;
    }

    const image = this.card.querySelector("[data-trending-image]");
    if (image && variant.image) {
      image.removeAttribute("srcset");
      image.removeAttribute("sizes");
      image.src = variant.image;
    }

    const priceEl = this.card.querySelector("[data-trending-price]");
    if (priceEl) priceEl.innerHTML = variant.priceHtml;

    const comparePriceEl = this.card.querySelector("[data-trending-compare-price]");
    if (comparePriceEl) {
      if (variant.comparePriceHtml) {
        comparePriceEl.innerHTML = variant.comparePriceHtml;
        comparePriceEl.hidden = false;
      } else {
        comparePriceEl.innerHTML = "";
        comparePriceEl.hidden = true;
      }
    }

    const badge = this.card.querySelector("[data-trending-badge]");
    if (badge) {
      if (variant.discount > 0) {
        badge.textContent = `-${variant.discount}%`;
        badge.hidden = false;
      } else {
        badge.hidden = true;
      }
    }

    const idInput = this.card.querySelector('product-form input[name="id"]');
    if (idInput) idInput.value = variant.id;

    if (submitButton) {
      submitButton.disabled = !variant.available;
      submitButton.classList.toggle("opacity-0_7", !variant.available);
    }
  }
}

customElements.define("trending-swatches", TrendingSwatches);

let suppressNextVariantClick = false;

document.addEventListener("pointerdown", (event) => {
  suppressNextVariantClick = false;
  if (event.pointerType !== "mouse" || event.button !== 0) return;

  const row = event.target.closest(".trending-swatches__row");
  if (!row) return;

  event.preventDefault();
  const startX = event.clientX;
  const startScrollLeft = row.scrollLeft;
  let dragged = false;

  const onMove = (moveEvent) => {
    const dx = moveEvent.clientX - startX;
    if (!dragged && Math.abs(dx) < 5) return;
    dragged = true;
    row.scrollLeft = startScrollLeft - dx;
  };

  const onUp = () => {
    window.removeEventListener("pointermove", onMove);
    window.removeEventListener("pointerup", onUp);
    suppressNextVariantClick = dragged;
  };

  window.addEventListener("pointermove", onMove);
  window.addEventListener("pointerup", onUp);
});

document.addEventListener(
  "click",
  (event) => {
    if (!suppressNextVariantClick) return;
    suppressNextVariantClick = false;
    event.stopPropagation();
    event.preventDefault();
  },
  true
);

document.addEventListener(
  "wheel",
  (event) => {
    const row = event.target.closest(".trending-swatches__row");
    if (!row || Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;

    const maxScrollLeft = row.scrollWidth - row.clientWidth;
    const atStart = row.scrollLeft <= 0 && event.deltaY < 0;
    const atEnd = row.scrollLeft >= maxScrollLeft && event.deltaY > 0;
    if (maxScrollLeft <= 0 || atStart || atEnd) return;

    event.preventDefault();
    row.scrollLeft += event.deltaY;
  },
  { passive: false }
);
